import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Collapse } from "reactstrap";
import withRouter from "components/Common/withRouter";
import classname from "classnames";
import Config from "config";
// i18n
import { withTranslation } from "react-i18next";

import { connect } from "react-redux";

const Navbar2 = (props) => {
  const backUrl = Config.backOffice.url;
  const api = Config.backOffice.apiName;
  const maxItems = 6;
  const menu = JSON.parse(localStorage.getItem("sideBar_" + api));
  const [showAllMenu, setShowAllMenu] = useState(false);
  const visibleItems = showAllMenu ? menu : menu.slice(0, maxItems);
  const hiddenItems = showAllMenu ? [] : menu.slice(maxItems);
  const [showSubMenu, setShowSubMenu] = useState(
    Array(hiddenItems.length).fill(false)
  );

  const activateMenuItem = () => {
    const ul = document.getElementById("navigation");
    const items = ul.getElementsByTagName("a");
    removeActivation(items);

    for (let i = 0; i < items.length; ++i) {
      if (
        window.location.pathname === items[i].getAttribute("href") ||
        window.location.pathname.startsWith(items[i].getAttribute("href"))
      ) {
        activateParentDropdown(items[i]);
        break;
      }
    }
  };
  useEffect(() => {
    activateMenuItem();
  }, [activateMenuItem]);
  const removeActivation = (items) => {
    for (let i = 0; i < items.length; ++i) {
      const item = items[i];
      const parent = item.parentElement;
      if (item.classList.contains("active")) {
        item.classList.remove("active");
      }
      if (parent && parent.classList.contains("active")) {
        parent.classList.remove("active");
      }
    }
  };

  const activateParentDropdown = (item) => {
    item.classList.add("active");
    let parent = item.parentElement;
    while (parent) {
      if (parent.tagName === "LI") {
        parent.classList.add("active");
      }
      parent = parent.parentElement;
    }
  };

  const handleSubMenuClick = (index) => {
    const updatedSubMenu = [...showSubMenu];
    updatedSubMenu[index] = !updatedSubMenu[index];
    setShowSubMenu(updatedSubMenu);
  };

  return (
    <React.Fragment>
      <div className="topnav">
        <div className="container-fluid">
          <nav
            className="navbar navbar-light navbar-expand-lg topnav-menu"
            id="navigation"
          >
            <Collapse
              isOpen={props.leftMenu}
              className="navbar-collapse"
              id="topnav-menu-content"
            >
              <ul className="navbar-nav">
                {visibleItems.map((menu, index) => (
                  <li key={index} className="nav-item dropdown">
                    {menu.children && menu.children.length > 0 ? (
                      <Link
                        className="nav-link dropdown-toggle arrow-none"
                        onClick={(e) => {
                          e.preventDefault();
                          setShowSubMenu(!showSubMenu);
                        }}
                        to={"/null"}
                      >
                        <i
                          className={classname({
                            "bx bx-package":
                              props.t(menu.father.name) === "PME",
                            "bx bx-cog": props.t(menu.father.name) === "Config",
                            "bx bx-file":
                              props.t(menu.father.name) ===
                              "Fusion documentaire",
                            "mdi mdi-handshake":
                              props.t(menu.father.name) === "Partenaires",
                            "mdi mdi-wallet-plus-outline":
                              props.t(menu.father.name) === "Souscriptions",
                            "bx bx-user-plus":
                              props.t(menu.father.name) === "Administration",
                          })}
                        ></i>
                        &nbsp;
                        <span style={{ fontSize: "12px" }}>
                          {props.t(menu.father.name)}
                        </span>
                        <div className="arrow-down"></div>
                      </Link>
                    ) : (
                      <Link
                        to={`${backUrl}/${menu.father.route}`}
                        className="nav-link text-nowrap"
                      >
                        <i
                          className={classname({
                            "bx bx-home-circle":
                              props.t(menu.father.name) === "Tableau de bord",
                            "mdi mdi-account-multiple-outline":
                              props.t(menu.father.name) === "Investisseurs",
                            "bx bx-file-blank":
                              props.t(menu.father.name) === "Mes documents",
                            "bx bx-printer":
                              props.t(menu.father.name) === "Impressions",
                            "mdi mdi-wallet-plus-outline":
                              props.t(menu.father.name) ===
                              "Mes participations",
                            "bx bx-wallet":
                              props.t(menu.father.name) === "Mes CGP",
                            "bx bx-user-circle":
                              props.t(menu.father.name) === "Mes informations",
                            "bx bx-log-out":
                              props.t(menu.father.name) === "Déconnexion",
                            "bx bxs-file-doc":
                              props.t(menu.father.name) ==
                              "Mes documents personnels",
                          })}
                        ></i>
                        &nbsp;
                        <span style={{ fontSize: "12px" }}>
                          {props.t(menu.father.name)}
                        </span>
                      </Link>
                    )}
                    {menu.children && menu.children.length > 0 && (
                      <div
                        className={classname("dropdown-menu", {
                          show: showSubMenu[index],
                        })}
                      >
                        {menu.children.map((child, childIndex) => (
                          <Link
                            key={childIndex}
                            to={`${backUrl}/${child.route}`}
                            className={classname("dropdown-item", {
                              "mm-active":
                                window.location.pathname ===
                                  `${backUrl}/${child.route}` ||
                                window.location.pathname.startsWith(
                                  `${backUrl}/${child.route}`
                                ),
                            })}
                          >
                            {props.t(child.name)}
                          </Link>
                        ))}
                      </div>
                    )}
                  </li>
                ))}
                {hiddenItems.length > 0 && (
                  <li className="nav-item dropdown">
                    <Link
                      className="nav-link dropdown-toggle arrow-none"
                      to="#"
                      onClick={(e) => {
                        e.preventDefault();
                        setShowAllMenu(!showAllMenu);
                      }}
                    >
                      <span style={{ fontSize: "12px" }}>
                        Voir tout le menu
                      </span>
                      <div className="arrow-down"></div>
                    </Link>
                    <div
                      className={classname("dropdown-menu", {
                        show: showAllMenu,
                      })}
                    >
                      {hiddenItems.map((item, itemIndex) => (
                        <div key={itemIndex} className="dropdown">
                          <Link
                            className={classname(
                              "dropdown-item dropdown-toggle",
                              {}
                            )}
                            to={`${backUrl}/${item.father.route}`}
                          >
                            {props.t(item.father.name)}
                            {item.children && item.children.length > 0 && (
                              <div className="arrow-down"></div>
                            )}
                          </Link>
                          {item.children &&
                          item.children.length === 0 ? null : (
                            <div
                              className={classname("dropdown-menu", {
                                show: showSubMenu[itemIndex],
                              })}
                            >
                              {item.children.map((child, childIndex) => (
                                <Link
                                  key={childIndex}
                                  to={`${backUrl}/${child.route}`}
                                  className="dropdown-item"
                                >
                                  {props.t(child.name)}
                                </Link>
                              ))}
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  </li>
                )}
              </ul>
            </Collapse>
          </nav>
        </div>
      </div>
    </React.Fragment>
  );
};

Navbar2.propTypes = {
  leftMenu: PropTypes.any,
  location: PropTypes.any,
  t: PropTypes.any,
};

const mapStatetoProps = (state) => {
  const { leftMenu } = state.Layout;
  return { leftMenu };
};

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(Navbar2))
);
